import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.CATEGORIES,
  nodeType: Generator.NODETYPE.GET
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/categories/get.js